// Layout.jsx
import React, { useState, useContext,createContext } from "react";
import { useAuth } from '../context/AuthContext';
import Sidebar from "../components/SideBar";
import FloatingDateBar from "../components/FloatingDateBar";

export const DateContext = createContext();

export const useDate = () => {
  const context = useContext(DateContext);
  if (!context) {
    throw new Error('useDate debe usarse dentro de DateProvider');
  }
  return context;
};

function Layout({ children,currentView,onViewChange }) {
  const { logout,restartSetPass } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  const handleLogout = () => {
    restartSetPass()
    logout()
  };

  const dateContextValue = {
    currentDate,
    setCurrentDate,
    isLoading,
    setIsLoading
  };

  return (
    <DateContext.Provider value={dateContextValue}>
      <div style={{ display: "flex", minHeight: "100vh", background: '#0f0f12' , overflowX: 'hidden'}}>
        <Sidebar
          isOpen={sidebarOpen}
          currentView={currentView}
          onToggle={toggleSidebar}
          onViewChange={onViewChange}
          onLogout={handleLogout}
        />
        <main style={{ 
          flex: 1, 
          marginLeft: window.innerWidth <= 768 
            ? (sidebarOpen ? "280px" : "0px") 
            : (sidebarOpen ? "280px" : "72px"),
          transition: "margin-left 0.3s ease",
          background: '#0f0f12',
          minHeight: '100vh',
        }}>
          <FloatingDateBar 
            currentDate={currentDate}
            onDateChange={setCurrentDate}
            loading={isLoading}
            onToggleSidebar={toggleSidebar}
          />
          <div style={{ paddingTop: '0px' }}>
            {children}
          </div>
        </main>
      </div>
    </DateContext.Provider>
  );
}

export default Layout;